@if (label()) {
  <label class="text-xs font-medium text-foreground-primary-60">
    {{ label() }}
    @if (isRequired()) {
      <span class="text-status-error">*</span>
    }
  </label>
}
<mat-date-range-picker
  #picker
  [disabled]="isDisabled"
  [title]="datepickerTitle"
  [onlyView]="onlyView"
  [optional]="optional"
  [dateRangePresets]="dateRangePresets"
>
  @if (isAction) {
    <mat-datepicker-actions></mat-datepicker-actions>
  }
</mat-date-range-picker>

<div class="flex flex-col">
  <div class="flex relative">
    @if (isLoading()) {
      <div
        class="absolute inset-0 z-[1] rounded-radius-container font-semibold text-sm text-action-primary whitespace-nowrap bg-background-fixed border border-[transparent] flex items-center cursor-default"
        [ngClass]="[inputClasses(), size === 'large' ? 'h-[45px]' : 'h-[36px]', isLoading() ? 'px-[13px]' : 'px-[44px]']"
      >
        <app-loading-skeleton backgroundTextClass="text-background-fixed" class="w-[130px] h-5" viewBox="0 0 130 20">
          <svg:rect x="0" y="0" rx="5" ry="5" width="130px" height="20px" />
        </app-loading-skeleton>
      </div>
    }
    <mat-date-range-input
      [rangePicker]="picker"
      [formGroup]="range"
      [disabled]="isDisabled"
      [min]="minimumDate"
      [max]="maximumDate"
      [allowFreeText]="allowFreeText"
      class="rounded-radius-container font-semibold text-sm text-action-primary whitespace-nowrap bg-background-fixed px-[44px] border"
      [ngClass]="[
        inputClasses(),
        size === 'large' ? 'h-[45px]' : 'h-[36px]',
        error() ? 'border-status-error' : 'border-[transparent]',
        isDisabled ? '[&&]:text-custom-disabled-input-color [&&&]:bg-custom-disabled-input-background' : '',
        isLoading() ? 'invisible pointer-events-none' : '',
      ]"
      [class.cursor-pointer]="!isDisabled && !isLoading()"
      [class.cursor-default]="isDisabled || isLoading()"
      (click)="!allowFreeText && !isLoading() && picker.open()"
    >
      <input
        #startInput
        matStartDate
        class="text-action-primary placeholder:text-action-primary"
        [ngClass]="
          isDisabled
            ? 'placeholder:[&&&]:text-custom-disabled-input-color [&&&]:text-custom-disabled-input-color [&&&&]:bg-custom-disabled-input-background'
            : ''
        "
        [formControl]="range.controls.start"
        [placeholder]="startPlaceholder"
        (focus)="onInputFocusOrBlur()"
        (blur)="onInputFocusOrBlur()"
      />
      <input
        #endInput
        matEndDate
        class="text-action-primary placeholder:text-action-primary"
        [ngClass]="
          isDisabled
            ? 'placeholder:[&&&]:text-custom-disabled-input-color [&&&]:text-custom-disabled-input-color [&&&&]:bg-custom-disabled-input-background'
            : ''
        "
        [formControl]="range.controls.end"
        [placeholder]="endPlaceholder"
        (focus)="onInputFocusOrBlur()"
        (blur)="onInputFocusOrBlur()"
      />
    </mat-date-range-input>
    <div class="absolute h-full top-0 left-0 flex items-center pointer-events-none text-action-primary pl-3">
      <svg-icon key="calendar-24" size="24" (click)="allowFreeText && !isLoading() && picker.open()" />
    </div>
    <div class="absolute h-full top-0 right-0 flex items-center pointer-events-none text-action-primary pr-3">
      <svg-icon key="chevron-down-16" size="16" (click)="allowFreeText && !isLoading() && picker.open()"></svg-icon>
    </div>
    @if (!errorInFlow()) {
      <div class="absolute top-[calc(100%_+_4px)] left-0 w-full text-xs font-medium text-status-error">
        {{ error() ?? '' }}
      </div>
    }
  </div>
  @if (errorInFlow() && error(); as error) {
    <div class="mt-1 w-full text-xs font-medium text-status-error">{{ error }}</div>
  }
  <!-- <span *ngIf="hintMessage" class="font-normal text-x-small text-text-700 pt-1">{{ hintMessage }}</span>
  <span *ngIf="errorMessage" class="font-normal text-x-small text-error-500 pt-1">{{ errorMessage }}</span>
  <span *ngIf="warningMessage" class="font-normal text-x-small text-warning-600 pt-1">{{ warningMessage }}</span> -->
</div>
